import * as React from 'react';
import { Provider } from 'react-redux';
import * as persisStore from 'src/redux/store';
import I18N from 'src/services/I18NService';
import './App.css';
import RoutersConfig from './routers';
import { PersistGate } from 'redux-persist/integration/react';
import { ConfigProvider } from 'antd';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import zh_TW from 'antd/lib/locale-provider/zh_TW';
import en_US from 'antd/lib/locale-provider/en_US';
import ja_JP from 'antd/lib/locale-provider/ja_JP';
import moment from 'moment';
import 'moment/locale/zh-cn';

interface IAppState {
  initDone: boolean;
  language: string;
}

interface IAppProps {}

class App extends React.Component<IAppProps, IAppState> {
  state: IAppState;

  constructor(props: IAppProps) {
    super(props);

    const { store } = persisStore;
    const languageState = store.getState().languageState;

    this.state = {
      initDone: false,
      language: languageState.language,
    };
  }

  componentDidMount() {
    this.loadLocales();
    this.setTitle();

    const { store } = persisStore;
    store.subscribe(() => {
      const languageState = store.getState().languageState;
      if (languageState.language !== this.state.language) {
        this.setState({ language: languageState.language });
      }
    });
  }

  loadLocales() {
    I18N.init().then(() => {
      this.setState({ initDone: true });
    });
  }

  setTitle() {
    document.title = I18N.get('common_partner_title');
  }

  public render() {
    const { store, persistor } = persisStore;
    const { language } = this.state;

    let locale: any = zh_CN;
    if (language === 'en') {
      locale = en_US;
      moment.locale('en');
    } else if (language === 'ja') {
      locale = ja_JP;
      moment.locale('ja');
    } else if (language === 'zh-tw') {
      locale = zh_TW;
      moment.locale('zh-tw');
    } else {
      moment.locale('zh-cn');
    }

    return (
      this.state.initDone && (
        <ConfigProvider locale={locale}>
          <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              <RoutersConfig />
            </PersistGate>
          </Provider>
        </ConfigProvider>
      )
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx